module.exports = new __parcel__URL__("80x35.ed7a7570.webp").toString();